import React, { ReactElement } from 'react';

import { Story } from 'graphql/generated/graphql';

import useHandleAVSRedirect from 'hooks/useHandleAVSRedirect';

interface IProps {
  story: Pick<Story, 'id' | 'femtasyRed'>;
  children: ReactElement;
}

const PlayButtonWrapper = ({ story, children }: IProps) => {
  const { handleAVSRedirect } = useHandleAVSRedirect(
    story.femtasyRed,
    children.props.onClick,
  );

  const onProtectedClick = React.useCallback(() => {
    handleAVSRedirect();
  }, [handleAVSRedirect]);

  return React.cloneElement(children, {
    ...children.props,
    onClick: onProtectedClick,
  });
};

export default PlayButtonWrapper;
